import type { PaymentMethod } from '@/pages/cms/billing/types';

// ACH bank debits can take up to 5 business days to clear, unlike cards - so they're not allowed
// where a flow needs an immediate payment result: paying down an invoice, buying credits, or
// upgrading a plan right now.
export const NOT_ALLOWED_PAYMENT_TYPES: PaymentMethod['type'][] = ['us_bank_account'];
